import React, { useEffect, useMemo } from 'react';
import { formatPrice } from '../../../../../../../../../common/utils/formattingUtils';
import OmnitureUtils from '../../../../../../../../../common/utils/Omniture/OmnitureUtils';
import { faOnRecentViewedCardClick, faOnRecentViewedCardView } from '../analytics-services';
import './styles.scss';

const RecentlyViewedCard = ({ packageDetails, sectionIndex, cardIndex }) => {
  useEffect(() => {
    if (packageDetails.packageId) {
      faOnRecentViewedCardView({ cardIndex, packageId: packageDetails.packageId, sectionIndex });
    }
  }, []);
  const paxString = useMemo(() => {
    let adultString = '';
    let childString = '';
    let infantString = '';
    let adultCount = 0;
    const childCount = 0;
    let infantCount = 0;

    packageDetails?.rooms?.forEach(room => {
      adultCount += room.noOfAdults || 0;
      adultCount += (room.noOfChildrenWB || 0) + (room.noOfChildrenWOB || 0);
      infantCount += room.noOfInfants || 0;
    });

    if (adultCount) {
      adultString += adultCount === 1 ? '1 Adult' : `${adultCount} Adults`;
    }
    if (childCount) {
      childString += childCount === 1 ? ' 1 Child' : `${childCount} Children`;
    }
    if (infantCount) {
      infantString += infantCount === 1 ? ' 1 Infant' : `${infantCount} Infants`;
    }

    return [adultString, childString, infantString].filter(str => !!str).join(', ');
  }, [packageDetails]);

  const handleCardClick = () => {
    OmnitureUtils.trackClickEvent({
      prop54: `RVS_Section_${sectionIndex}_Card_${cardIndex}`,
    });
    faOnRecentViewedCardClick({ cardIndex, packageId: packageDetails.packageId, sectionIndex });
    window.open(packageDetails?.packageShareUrl);
  };

  return (
    <div onClick={handleCardClick} className="viewedCard">
      <span className="htlImage">
        <img
          src={packageDetails?.imageDetail?.mainImage?.fullPath}
          alt="Recently viewed package Image"
        />
      </span>
      <div className="innerDetails">
        <h3 className="heading trunket">{packageDetails?.name}</h3>
        <p className="description">
          {paxString} {packageDetails?.destinationDetail?.duration}N/
          {packageDetails?.destinationDetail?.duration || 0 + 1}D
        </p>
        <p className="price">{formatPrice(packageDetails?.priceDetail?.discountedPrice)}</p>
      </div>
    </div>
  );
};

export default RecentlyViewedCard;
